import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { MutationKeys } from "constants/mutation-keys";
import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { IDeleteAttachmentPayload } from "store/entities/tickets/interfaces";
import { ToastVariant, ToastsActions } from "store/features/toasts";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useAttachmentDeletion = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: [MutationKeys.Attachment],
    mutationFn: async (payload: IDeleteAttachmentPayload) => {
      const { error } = await ApiManager.ticketApi.deleteAttachment(
        payload.ticketId,
        payload.eventId,
        payload.attachmentId
      );
      if (error) {
        dispatch(
          ToastsActions.createToast({
            variant: ToastVariant.Error,
            content: getToastContent(ToastContent.ATTACHMENT_DELETE_FAILURE),
          })
        );
      } else {
        dispatch(
          ToastsActions.createToast({
            variant: ToastVariant.Success,
            content: getToastContent(ToastContent.ATTACHMENT_DELETE_SUCCESS),
          })
        );
      }
      return error;
    },
  });
};
